import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import { useEffect, useState } from 'react';

interface AvatarProps {
  className?: string;
  alt?: string;
  style?: React.CSSProperties;
}

export function Avatar({ className = '', alt = 'Dieter', style }: AvatarProps) {
  const { whitelabelConfig, whitelabelLoading: loading } = useUserWithCompany();
  const [avatarB64, setAvatarB64] = useState<string | null>('unset');

  // setting the global whitelabel avatar
  useEffect(() => {
    if (whitelabelConfig) {
      setAvatarB64(whitelabelConfig.avatarB64 || null);
    }
  }, [whitelabelConfig]);

  if (loading) {
    return null;
  }

  // Use custom avatar if available, otherwise fall back to default dieter_kopf.svg
  const avatarSrc = avatarB64 && avatarB64 !== 'unset' 
    ? avatarB64 
    : '/assets/images/dieter_kopf.svg';

  const displayAlt = whitelabelConfig?.avatarName || alt;

  return (
    <img 
      className={className} 
      src={avatarSrc} 
      alt={displayAlt} 
      style={style}
    />
  );
}
